import { orchestrator } from 'satcheljs';
import {
    OAuthProviderType,
    lazyLinkAccountAndGetAccessToken,
    ConnectedAccountResponse,
    ErrorResponse,
} from 'owa-link-account';
import { addSeconds, now } from 'owa-datetime';
import { trace } from 'owa-trace';
import { addOWAConnectedAccount } from 'owa-accounts-store';
import {
    connectOWAConnectedAccountFailed,
    connectOWAAccount,
    accountConnected,
} from '../actions/publicActions';

orchestrator(connectOWAAccount, async ({ accountProviderType }) => {
    if (accountProviderType == 'Outlook' || accountProviderType == 'Google') {
        // to do: use the API provider by Auth team to add an account for given provider
        const providerType =
            accountProviderType == 'Google' ? OAuthProviderType.Google : OAuthProviderType.Msa;

        const response = await lazyLinkAccountAndGetAccessToken.importAndExecute(providerType);
        const responseError = response as ErrorResponse;

        // once connected, the use the response to store the account details in client store
        if (!responseError.error) {
            const res = response as ConnectedAccountResponse;
            const tokenExpiration = parseInt(res.token.expiresIn);
            addOWAConnectedAccount({
                primarySmtpAddress: res.userAccount.emailAddress,
                displayEmail: res.userAccount.emailAddress,
                accountId: res.userAccount.id,
                anchorMailbox: res.userAccount.routingHint,
                token: res.token.accessToken,
                accountProviderType: accountProviderType,
                tokenExpiry: addSeconds(now(), tokenExpiration),
                isAccountValid: tokenExpiration > 0,
            });

            // Announce account connected, so that we can enable truetime by default
            accountConnected(res.userAccount.emailAddress);
        } else {
            let error = responseError ? responseError.error : 'Unknown';
            trace.warn('connectOWAAccount failed with Error: ' + error);
            connectOWAConnectedAccountFailed();
        }
    } else {
        throw new Error(`${accountProviderType} provider is not yet supported for OWA Calendar`);
    }
});
